import { forwardRef, type InputHTMLAttributes } from 'react';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string;
};

export const Input = forwardRef<HTMLInputElement, Props>(
  ({ label, error, className = '', ...props }, ref) => (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label className="block text-[11px] font-bold text-muted uppercase tracking-[0.12em]">
          {label}
        </label>
      )}
      <input
        ref={ref}
        {...props}
        className={`w-full bg-bg px-3 py-2.5 text-sm text-text placeholder-muted outline-none transition-colors rounded-xl ${error ? 'border border-danger' : ''} ${className}`}
      />
      {error && <p className="text-xs text-danger mt-0.5">{error}</p>}
    </div>
  ),
);
Input.displayName = 'Input';
